import Card from '../Components/Card'
import { useEffect } from 'react'
import '../App.css'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllDataAmibo } from '../Store/actions'

function Home () {
  const dataApiAmibo = useSelector(state => state.apiAmibo.dataApiAmibo)
  const loading = useSelector(state => state.apiAmibo.loading)
  const error = useSelector(state => state.apiAmibo.error)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAllDataAmibo())
  }, [dispatch])

  if(loading) {
    return (
    <div className="App">
      <h1>Icon Characters in Mario Bros</h1>
      <h3>loading ....</h3>
    </div>
    )
  }
  if(error) {
    return (
      <div className="App">
        <h1>Icon Characters in Mario Bros</h1>
        <h3>error to fetch data</h3>
      </div>
    )
  }
  return (
    <div className="App">
      <h1 className="m-4" >All Characters in Mario Bros</h1>
      <div className="container">
        <div className="row">
          {
            dataApiAmibo.map((dataAmibo) => (
              <div key= {dataAmibo.tail}>
                <Card data={dataAmibo}/>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  ) 
}

export default Home